/**
 * An enum of the different user types.
 * (mapped to string values that the API recognizes)
 */
export enum UserTypeEnum {
  Attorney = 'AT',
  Clerk = 'CL',
  CourtManager = 'CM',
  CustomerService = 'CS',
  FileAndServeBasicUser = 'EC',
  StaffMember = 'FC',
  FirmManager = 'FM',
  IT = 'IT',
  Judge = 'JU',
  Management = 'LM',
  NonSubscribingUser = 'NA',
  NonSubscribingJudgeUser = 'NJ',
  PublicAccessUser = 'PA',
  SystemAdmin = 'SA',
  SelfRepresented = 'SR',
  TechnicalAssistant = 'TA',
  ThirdPartyFiler = 'TP',
  Form50Agent = 'FF'
}

/**
 * An interface to define the structure of each user type constant
 */
export interface UserTypeObj {
  caption: string;
  value: UserTypeEnum;
}

/**
 * An abstract class containing all the user type constants.
 */
export abstract class UserTypeConstants {
  static readonly Attorney: UserTypeObj = { caption: 'Attorney', value: UserTypeEnum.Attorney };
  static readonly Clerk: UserTypeObj = { caption: 'Clerk', value: UserTypeEnum.Clerk };
  static readonly CourtManager: UserTypeObj = { caption: 'Court Manager', value: UserTypeEnum.CourtManager };
  static readonly CustomerService: UserTypeObj = { caption: 'Customer Service', value: UserTypeEnum.CustomerService };
  static readonly FileAndServeBasicUser: UserTypeObj = { caption: 'File & Serve Basic User', value: UserTypeEnum.FileAndServeBasicUser };
  static readonly StaffMember: UserTypeObj = { caption: 'Staff Member', value: UserTypeEnum.StaffMember };
  static readonly FirmManager: UserTypeObj = { caption: 'Firm Manager', value: UserTypeEnum.FirmManager };
  static readonly IT: UserTypeObj = { caption: 'IT', value: UserTypeEnum.IT };
  static readonly Judge: UserTypeObj = { caption: 'Judge', value: UserTypeEnum.Judge };
  static readonly Management: UserTypeObj = { caption: 'Management', value: UserTypeEnum.Management };
  static readonly NonSubscribingUser: UserTypeObj = { caption: 'Non-Subscribing User', value: UserTypeEnum.NonSubscribingUser };
  static readonly NonSubscribingJudgeUser: UserTypeObj = { caption: 'Non-Subscribing Judge User', value: UserTypeEnum.NonSubscribingJudgeUser };
  static readonly PublicAccessUser: UserTypeObj = { caption: 'Public Access User', value: UserTypeEnum.PublicAccessUser };
  static readonly SystemAdmin: UserTypeObj = { caption: 'System Administrator', value: UserTypeEnum.SystemAdmin };
  static readonly SelfRepresented: UserTypeObj = { caption: 'Self-Represented', value: UserTypeEnum.SelfRepresented };
  static readonly TechnicalAssistant: UserTypeObj = { caption: 'Technical Assistant', value: UserTypeEnum.TechnicalAssistant };
  static readonly ThirdPartyFiler: UserTypeObj = { caption: 'Third-Party Filer', value: UserTypeEnum.ThirdPartyFiler };
  static readonly Form50Agent: UserTypeObj = { caption: 'DE Form 50 Agent Type', value: UserTypeEnum.Form50Agent };

  /**
   * Returns all user type objects as an array to make deriving dropdown options easier.
   */
  static getAll(): UserTypeObj[] {
    return Object.values(UserTypeConstants) as UserTypeObj[];
  }
}
